import PropTypes from 'prop-types';
import React, { createRef } from 'react';
import { findDOMNode } from 'react-dom';
import { UX2, constants } from '@wsb/guac-widget-core';
import {
  RouteHandler,
  ShopViewConstants,
  ScrollWidgetActions
} from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';

import * as Metrics from '../utils/trackMetric';
import * as MetricEvents from '../../../constants/metrics';

import DrawerMobile from './DrawerMobile';
import SlideDesktop from './SlideDesktop';

const getStyles = ({ listHeight, limitContainer }) => ({
  outer: {
    position: 'relative',
    height: '100%',
    minHeight: listHeight < 400 ? listHeight + 40 + 'px' : '400px',
    flex: 1,
    width: '100%'
  },
  innerDesktop: {
    'position': 'absolute',
    'width': '100%',
    'top': '0px',
    'bottom': '0px',
    '@xs-only': {
      display: 'none'
    }
  },
  listOuter: {
    position: 'absolute',
    top: '0',
    bottom: '0px',
    width: '100%',
    overflow: 'auto',
    borderBottomWidth: limitContainer ? '1px' : '0',
    borderBottomStyle: limitContainer ? 'solid' : 'none',
    borderColor: 'uLowContrastOverlay'
  },
  listInner: {
    position: 'relative',
    paddingBottom: 'medium'
  },
  fadeTop: {
    position: 'absolute',
    bottom: '4px',
    display: limitContainer ? 'block' : 'none',
    width: '100%',
    height: '6px',
    backgroundColor: 'section',
    opacity: '0.4'
  },
  fadeBottom: {
    position: 'absolute',
    bottom: '1px',
    display: limitContainer ? 'block' : 'none',
    width: '100%',
    height: '3px',
    backgroundColor: 'section',
    opacity: '0.6'
  },
  innerMobile: {
    'position': 'relative',
    'flexDirection': 'column',
    '@sm': {
      display: 'none'
    }
  }
});

export default class CategoryList extends React.Component {
  constructor() {
    super(...arguments);
    this.handleCategoryClick = this.handleCategoryClick.bind(this);
    this.state = { limitContainer: false, listHeight: 0 };
    this.desktopInnerRef = createRef();
  }

  componentDidMount() {
    this.calculateCatHeight();
  }

  UNSAFE_componentWillReceiveProps() {
    this.calculateCatHeight();
  }

  calculateCatHeight() {
    this.desktopInnerNode = findDOMNode(this.desktopInnerRef.current);
    if (this.desktopInnerNode) {
      const listHeight = this.desktopInnerNode.offsetHeight;
      const containerHeight = this.desktopInnerNode.parentElement.offsetHeight;
      this.setState({ listHeight, limitContainer: listHeight > containerHeight });
    }
  }

  scrollMobileToTop() {
    const mobileInnerNode = findDOMNode(this.mobileInnerRef);
    if (mobileInnerNode) {
      mobileInnerNode.scrollTop = 0;
    }
  }

  handleCategoryClick(permalink, isAllProducts, e) {
    e.preventDefault();
    const { currentSortOption } = this.props;
    const data = { taxonPermalink: permalink };
    if (currentSortOption) {
      data.sortOption = currentSortOption;
    }
    if (isAllProducts) {
      data.routePath = RouteHandler.ALL_PRODUCTS_ROUTE;
    }
    Metrics.track(MetricEvents.CATEGORY_LIST_CATEGORY_CLICK);
    RouteHandler.navigate(ShopViewConstants.PRODUCT_LISTING, data);
    ScrollWidgetActions.scrollShopWidget();
    this.scrollMobileToTop();
  }

  render() {
    const { Block } = UX2.Element;
    const { limitContainer, listHeight } = this.state;
    const { taxons, renderMode, selectedTaxonPermalink, routePath, isSearch } = this.props;
    const styles = getStyles({ listHeight, limitContainer });
    const listProps = {
      taxons,
      routePath,
      isSearch,
      selectedTaxonPermalink,
      renderMode,
      onClick: renderMode === constants.renderModes.EDIT ? null : this.handleCategoryClick
    };

    return (
      <Block style={ styles.outer }>
        <Block style={ styles.innerDesktop }>
          <Block style={ styles.listOuter }>
            <Block ref={ this.desktopInnerRef } style={ styles.listInner }>
              <SlideDesktop { ...listProps } />
            </Block>
          </Block>
          <Block style={ styles.fadeTop } />
          <Block style={ styles.fadeBottom } />
        </Block>
        <Block style={ styles.innerMobile }>
          <Block
            ref={ ref => {
              this.mobileInnerRef = ref;
            } }
          >
            <DrawerMobile { ...listProps } />
          </Block>
        </Block>
      </Block>
    );
  }
}

CategoryList.propTypes = {
  taxons: PropTypes.array,
  selectedTaxonPermalink: PropTypes.string,
  isSearch: PropTypes.bool,
  currentSortOption: PropTypes.string,
  renderMode: PropTypes.string,
  routePath: PropTypes.any
};
